<template>
  <div>
    <video-grid-picker :videos="items" v-model="selectedTransition" />
  </div>
</template>

<script>
import VideoGridPicker from './VideoGridPicker'
import { mapState } from 'vuex'

export default {
  name: 'Transitions',

  props: ['value'],

  components: {
    VideoGridPicker
  },

  computed: {
    selectedTransition: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    ...mapState({
      items: state => state.videoettes.transitionItems
    })
  }
}
</script>
